export const normalizeLocationName = (name: string) => {
  // Convert to uppercase and handle special cases
  const upperName = name.toUpperCase();

  if (upperName.includes(" ")) {
    const parts = upperName.split(" ");
    if (parts.length === 2) {
      return `${parts[0]}-${parts[1]}`;
    }
    return upperName.replace(/\s+/g, "-");
  }

  return upperName;
};
